import React, { useState } from 'react'
import cx from 'classnames'
import dayjs from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Button from '@mui/material/Button'
import { ThemeProvider } from '@mui/material/styles'
import caTheme from './caTheme'
import dealwatchTheme from './dealwatchTheme'
import trainingTheme from './trainingTheme'
import { DISPLAY_DATE_FORMAT } from 'constants/locale'

const themes = {
  ca: caTheme,
  dealwatch: dealwatchTheme,
  training: trainingTheme
}

const CalenderDatePickers = ({
  fromDateSelected,
  toDateSelected,
  onHandleFromDateSelectedChange,
  onHandleToDateSelectedChange,
  onHandleButtonSubmit,
  disableSubmit = false,
  theme,
  showSubmitButton = true,
  datePickerPropOverrides = {}
}) => {
  const [isFromCalendarOpen, setIsFromCalendarOpen] = useState(false)
  const [isToCalendarOpen, setIsToCalendarOpen] = useState(false)
  const selectedTheme = themes[theme]

  const pickerProps = ({ selectedDate, isOpen, setIsOpen, handleChange }) => ({
    disableFuture: true,
    format: DISPLAY_DATE_FORMAT,
    value: selectedDate ? dayjs(selectedDate) : null,
    open: isOpen,
    onOpen: () => setIsOpen(true),
    onClose: () => setIsOpen(false),
    onChange: (date) => {
      if (date) {
        // Pass the dayjs value straight through - DateRangeFilter.js calls
        // .format() on it directly (a plain Date has no such method); the
        // other two consumers (useDatePicker.js) re-wrap with dayjs()
        // regardless, so this is a no-op for them either way.
        handleChange(date)
        setIsOpen(false)
      }
    },
    views: ['year', 'month', 'day'],
    openTo: 'day'
  })

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={selectedTheme}>
        <DatePicker
          label='From'
          maxDate={toDateSelected ? dayjs(toDateSelected) : undefined}
          {...pickerProps({
            selectedDate: fromDateSelected,
            isOpen: isFromCalendarOpen,
            setIsOpen: setIsFromCalendarOpen,
            handleChange: onHandleFromDateSelectedChange
          })}
          {...datePickerPropOverrides}
          slotProps={{
            textField: { variant: 'outlined', className: 'w-100 mt4 mb4' }
          }}
        />
        <DatePicker
          label='To'
          minDate={fromDateSelected ? dayjs(fromDateSelected) : undefined}
          {...pickerProps({
            selectedDate: toDateSelected,
            isOpen: isToCalendarOpen,
            setIsOpen: setIsToCalendarOpen,
            handleChange: onHandleToDateSelectedChange
          })}
          {...datePickerPropOverrides}
          slotProps={{
            textField: { variant: 'outlined', className: 'w-100 mb4' }
          }}
        />
        {showSubmitButton && (
          <Button
            variant='outlined'
            className={cx('w-100 white h3', {
              'bg-medium-aquamarine ca-search-date-submit-button': !disableSubmit && theme !== 'dealwatch',
              'bg-dark-sea-green-3 dealwatch-search-date-submit-button': !disableSubmit && theme === 'dealwatch',
              'bg-twilight-grey': disableSubmit
            })}
            onClick={onHandleButtonSubmit}
            disabled={disableSubmit}
          >
            Submit
          </Button>
        )}
      </ThemeProvider>
    </LocalizationProvider>
  )
}

export default CalenderDatePickers
